const artData = [
  {
    title: 'MIT Drawn Together',
    description: `<p>In light of the unjust deaths of George Floyd, Breonna 
    Taylor, Ahmaud Arbery, Tony McDade, and countless others, I joined the 
    <a href='https://www.instagram.com/p/CBLWPbOnWVm/' target='drawnTgt'>MIT 
    Drawn Together</a> project in June 2020. As a part of Drawn Together, I 
    accepted artwork commissions with proceeds going to organizations committed 
    to supporting the Black community and combating systemic racism. As of July 
    2020, Drawn Together raised over $3,000 directly from commissions and was 
    featured on <a href='https://www.instagram.com/p/CCZEC9rAlt2/' target=
    'drawnTgt'>MIT's official instagram</a>.</p>`,
  },
  {
    title: 'Crane Dancer',
    description: `<p>On the last day of my first semester of college, I took a 
    detour from my usual path between classes and ended up stumbling upon 
    <a href='http://cranes.mit.edu/about' target='cranes'>Collier's Cranes</a>, 
    a beautiful installation/hack honoring the late Officer Sean Collier. 
    Relieved to be done with a very, very long semester, I recall pausing under 
    the cranes to savor the light pouring in from the skylight. In that moment, 
    I felt free as a bird.</p> <p>Less than a week prior, I had been busy with 
    the <a href='http://adt.mit.edu/' target='ADT'>Asian Dance Team (ADT)</a> 
    end-of-semester showcase. Throughout the semester, I had gone to weekly rehearsals 
    as a part of the ADT group performing <ahref='https://youtu.be/MNCBfjJAWA8' 
    target='PickMe'>Pick Me</a>, but I hadn’t gotten the chance to see other ADT 
    groups perform. At showcase, I was mesmerized by the sheer beauty and grace 
    of the groups doing <a href='https://youtu.be/U3Mf8KR7490'target='dance'>
    traditional Asian dance</a>.</p><p>Inspired by these two experiences, I 
    decided to paint something. I had recently bought a graphics tablet and was 
    itching to try it out. Studying for finals gave me the perfect excuse to 
    procrastinate.</p><p>It took some experimentation with posing to get the 
    dancer’s form to resemble an origami crane. Though this piece took me 
    forever (Photoshop is not intuitive tbh), I am satisfied with how my 
    first digital painting turned out!</p>`,
  },
  {
    title: 'Fish out of Water',
    description: `<p>Photo Credits: Kevin Ly</p><p>Every August, the tents go up on 
      <a href='https://mitadmissions.org/blogs/entry/how-to-grow-a-vibrant-kresge/'
      target='kresge'>Kresge Lawn</a> to serve as home base for freshman orientation— 
      a timewhen many, including myself, might have felt like a fish out of water.</p>
      <p>My friend Kevin took this photo during freshman orientation before our 
      sophomore year, and it made me a bit nostalgic.</p>`,
  },
  {
    title: 'Liminal Space (zine)',
    description: `<i>A small zine about big changes and growing pains that cut deeper than a knife. </i>
				<br><br>
				<p>I thought the weeks in between
					submitting my master's thesis and beginning full-time work in NYC would offer some peaceful respite and time
					to reflect...
				</p>
				<p> On Friday night, I turned in my thesis, and on Saturday morning, I was virtually touring potential
					apartments with my future roommate. The hectic but mundane whirlwind of life events-- apartment hunting (read
					the fine print!); an involved team-matching process for my job; and cramming as many goodbye lunches/dinners
					with friends at school-- was itself a full-time job. Although perfectly manageable, it left no space to
					breathe and relax.
					Fortunately, I didn't feel awfully sentimental because this entire year was a slow burn goodbye to MIT, and I
					already got to spend
					longer than I had anticipated at school and with dear friends; it was about time to graduate and move on.
				</p>
				<!-- <p>
					Then things got worse. Difficult family circumstances arose which caused me to decide not to return home as
					planned. Consequently, for the first time in my life, I had to worry about
					having a place to sleep. Scrambling to figure out my own moving and housing logistics, I put aside my own
					feelings and the pain of a severed tie, tolerating a semi-regular stream of words, actions, and accusations
					that cut deeper than a knife. My life became almost absurd, forcing myself to maintain a bubbly
					demeanor in front of friends and future bosses and colleagues, while under the surface, I was helplessly
					drowning.
				</p> -->
				<p>
					Then things got worse. Difficult family circumstances (too personal to disclose) arose which caused me to worry
					about my moving and housing logistics, on top of being emotionally distressed to the point of affecting my physical health.
					Once my situation became a little more stable, owing to the generosity of my friends and support system at
					school, I began to draw, because "drawing is free therapy," as someone wrote on the wall of my floor
					kitchen. And it is. I spent two days feverishly drawing Liminal Space, finding comfort and satisfaction in the
					familiar
					lines, colors, and shapes. <b>I wanted to turn the ugliness and chaos of my personal life into something
						beautiful and orderly, and I didn't want to think about anything else. </b>I kept the art intentionally
					general, afraid to expose anything private, disturbing, or
					vindictive. I hardly allude to the root cause of my distress and focus instead on the generic uncertainty of
					post-college transition.
				</p>
				<p>
					And I think the generality of Liminal Space allowed it to strike a chord with surprisingly many people, with
					even acquaintances and strangers leaving comments online. I couldn't care less how my art fares on social
					media, but I'm glad that something born from such a
					terrible experience could bring others joy or comfort.
				</p>`,
  },
  {
    title: 'KoiQueen',
    description: `<p>Like most students, my first spring break in college was spent coding a <a
						href="http://web.mit.edu/6.031/www/sp19/psets/ps3/" target="memely">meme generator</a> (for class!) and painting a six-foot-tall canvas.
					The painting was part of a <a href="http://borderline.mit.edu/about.html"
						target="blAbout">Borderline</a> x <a href="http://ua.mit.edu/innovation" target="UAI">UA
						Innovation</a> project to add artwork to the <a
						href="https://thetech.com/2018/04/13/26-110-study-space" target="Banana">Banana Lounge
						(26-110)</a>, a beloved campus spot to pset, nap, and grab a free banana.
				</p>
				<p>The title of the piece is pure coincidence: 'KoiQueen' was the name of a node on my algorithms pset around the same time I was painting koi and a girl.
				KoiQueen is based on some art I did in high school and intended to reflect nothing more
					than the tranquility of the Banana Lounge.
				</p>`,
  },
  {
    title: 'Incandescent',
    description: `<p>I had been interested in <a href="http://borderline.mit.edu/about.html"
					target="borderline">Borderline</a>, a student organization responsible for the AR-animated murals in
					the tunnels under MIT, ever since seeing a <a href="http://borderline.mit.edu/blog.html#CPW"
					target="cpw">Borderline AR demo at Campus Preview Weekend</a>. During
					freshman fall, I applied to paint and animate a mural with Borderline. The design was based on a
					piece I did in high school (below) and the idea that people are like lightbulbs: they burn bright
					with ideas and shine on each other.
				</p>
				<p>
					Before working on Incandescent, I had never painted a mural nor done animation, but Borderline
					provided me with the supplies and training I needed. The mural took about a week to complete, and if
					I’m being honest, it turned out pretty different from what I had envisioned. I have mixed feelings
					towards Incandescent now, but I am satisfied with how the AR animation turned out. I’m
					grateful to Borderline for this opportunity to share my art, and I have since joined the Borderline exec
					team to help continue the tunnel and other Borderline projects.
				</p>`,
  },
  {
    title: 'Fog on the Charles',
    description: `<p> My sophomore year dorm room in <a
					href="http://mccormick.mit.edu/node/29" target="McC">McCormick Hall</a> had an amazing view of the Charles River. No matter how
					stressful things got at school, the tranquil view from my window never failed to make everything a
					little brighter. When I came home for winter break, I painted the nighttime view (bottom image).
				</p>
				<p>
					I was pleased with how the water and sky turned out, but felt I could do better with the
					composition and colors. At the end of the following semester, I redrew the Boston skyline as viewed
					from ground level rather than eighth-floor penthouse, this time paying special attention to colors and composition. I
					drew inspiration from the mesmerizing skyline paintings of one of my favorite artists, Ronald Kuang (<a
						href="https://www.instagram.com/seerlight/?hl=en" target="ronald">@seerlight</a>), whose palettes and work are exquisite. Equally exquisite is the work of Wenqing Yan 
					(<a href="https://www.instagram.com/yuumeiart/?hl=en" target="yuumei">@yuumeiart</a>), another of my favorite artists. I used Yuumei's digital cloud brushes in both of these paintings.
				</p>`,
  },
  {
    title: 'Dormspam Comic',
    description: `				<p>From January to March 2020, I drew a biweekly comic strip, <a href="https://thetech.com/search/images/gloria+lin"
						target="alldormspam"> Dormspam</a>, published in <a href="https://thetech.com/"
						target="ttt">The Tech</a> (MIT's newspaper).
					Much like the short-lived Spring 2020 semester, what started out as lighthearted doodles became
					depressing sketches on the state of campus. The final comic, “Techxodus,” was drawn days after
					evacuating MIT due to COVID-19. Dormspam subsequently went on hiatus.
				</p>
				<p>The title Dormspam comes from an MIT colloquialism** for sending an email to the mailing
					lists of all dorms. Sometimes satire and often times club event ads, dormspam (and the flame wars
					it can incite) is uniquely
					MIT, much like the niche humor I aimed for in the Dormspam comic, which made fun of topics such as
					<a href="https://en.wikipedia.org/wiki/MIT_class_ring" target="brassrat">Brass Rat</a>, <a
						href="https://xfair.io/" target="xfair">XFair</a>, <a href="https://thetech.com/photos/9372"
						target="purell">Purell dispensers</a>, and <a
						href="https://www.facebook.com/beaverconfessions/posts/2006248752777495" target="tetazoo">tetazoo
						glounge</a>.
				</p>
				<p>One rule for sending dormspam is that the sender must close the message by indicating the color of
					his or her underwear. Or any color, really. I've tried to pay homage to this tradition
					in the artist's signatures of Dormspam comics. I hope to continue Dormspam sometime in the future, when I'm
					feeling more inspired.
				</p>
				<p> **To my knowledge, “dormspam” is both a verb and a noun.
				</p>
				<p>
					** 2/2022 edit: I drew a few more Dormspam comics in Fall '21, all comics are available <a href="https://drive.google.com/drive/folders/1WKKzHod42q33svvekvrEPiifqBy8u4G-?usp=sharing" target="comics">here</a>.
				</p>`,
  },
  {
    title: 'Chinese Calligraphy',
    description: `
				<p>During IAP (Jan 2020), I took a <a href="https://calligraphy.mit.edu/class-info" target="calligraphy">Chinese
						calligraphy class</a> taught by <a
						href="http://news.mit.edu/2020/3-questions-kang-zhou-lessons-of-chinese-calligraphy-0128"
						target="zhou">Teacher Zhou 周老师</a>. The class met every
					day for three hours, and most students, like myself, had no prior experience doing Chinese
					calligraphy. 周老师 taught us not only calligraphy strokes and techniques, but also the history,
					philosophy, and evolution of Chinese calligraphy.
				</p>
        <p>
					The class coincided with Chinese New Year, so I was able to make
					many fortune 福 signs (like the one in the video!) to give to my friends and floormates, wishing them
					luck for the new year. I also made spring couplets 春联 to hang on my dorm door. The class culminated
					in a <a href="https://youtu.be/tSmpBCCA448" target="calligraphyYT">video project where my friend and I
						explored Boston Chinatown</a>, identifying different historical
					styles of calligraphy on signs, packaging, and landmarks, which we definitely would not have noticed before.
					谢谢周老师!
				</p>`,
  },
]

export default artData
